/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */

import get from 'lodash/get';
import moment from 'moment';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, WIDGET_API, WIDGET_MAX_COSTS } from '../../../../../modules/app/Api';
import { makeSelectLocalStorageSelectedAccount } from '../../../../../modules/storage/storageSelectors';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { widgetSubscriberMaxCostFail, widgetSubscriberMaxCostSuccess } from './widgetSubscriberMaxCostsActions';

export function* loadSubscribersListSaga(): SagaIterator {

    const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
    const from = moment().startOf('month').format('DD.MM.YYYY');
    const to = moment().endOf('month').format('DD.MM.YYYY');
    const URL = `${API_HOSTNAME}${WIDGET_API}${WIDGET_MAX_COSTS}/${selectedAccount}?from=${from}&to=${to}`;
    try {
        const response = yield call(requestSaga, URL, 'GET');

        const subscribers = get(response, 'subscribers', []);

        yield put(widgetSubscriberMaxCostSuccess({ subscribers }));

    } catch (error: any) {
        yield put(widgetSubscriberMaxCostFail(error));
    }
}
